<template>
  <transition name="fade">
    <div class="loader">
      <div class="spinner"></div>
    </div>
  </transition>

</template>
<script>
export default {
  name: "Loader"
};
</script>
